import React, { useEffect, useState } from 'react'
import CustomButton from '../../components/CommonComponents/CustomButton';
import { message } from 'antd';
import Loader from '../../loader';
import api from '../../api/apiClient';
import endpoints from '../../api/endpoints';
import CustomInput from '../../components/CommonComponents/CustomInput';
import config from '../../config';
import { timeAgo } from '../../util';
import { ButtonBase } from '@mui/material';
import { useLocation, useParams } from 'react-router-dom';

export default function Matches() {
  const routeParams = useParams();
  const id = routeParams.id;
  const [matchId, setMatchId] = useState(id || "");
  const [loading, setLoading] = useState(false);
  const [matchInfo, setMatchInfo] = useState("");
  const [latestMatches, setLatestMatches] = useState([]);
  const [refresh, setRefresh] = useState(false);


  const handleView = async () => {
    if(!matchId) return message.info("Enter the match id first!")
    setLoading(true);
    const res = await api.get(endpoints.agent.getMatchLog + `?id=${matchId}`);
    setLoading(false);
    if(res.code !== "200") {
      setMatchInfo("");
      return message.error(res.message);
    };

    setMatchInfo(res.data[0]);
  }

  const getLatestMatches = async () => {
    setLoading(true);
    const res = await api.get(endpoints.agent.getMatchLogLatest);
    setLoading(false);
    if(res.code !== "200") {
      return message.error(res.message);
    };

    setLatestMatches(res.data);
  }

  useEffect(() => {
    getLatestMatches();
  },[refresh])

  useEffect(() => {
    if(id) {
      handleView();
    }
  },[])

  return (
    <div className='page-content'>
        <div style={{display: 'flex', flexDirection: "row"}}>
          <CustomInput
            value={matchId}
            placeholder={"Enter Room:Match Id..."}
            onChange={(e) => setMatchId(e.currentTarget.value)}
            style={{width: "250px"}}
            search
          />
          <CustomButton disabled={loading} onClick={handleView} style={{marginLeft: "1rem"}}>View</CustomButton>
        </div>
        
        {loading && <Loader width='30px' height='30px'/>}

        {!loading && matchInfo &&
        <div style={{marginTop: "30px", padding: "20px", backgroundColor: "#2A3042", borderRadius: "5px"}}>
          <div className='d-flex' style={{marginBottom: "10px"}}>
            <h5 style={{width: "120px", color: config.color.textColor}}>Match Id</h5>
            <h5 style={{width: "50px"}}>-</h5>
            <h5 style={{marginLeft: "5px", color: config.color.secondaryColor}}>{matchInfo.match_id}</h5>
          </div>
          <div className='d-flex' style={{marginBottom: "10px"}}>
            <h5 style={{width: "120px",color: config.color.textColor}}>Room Id</h5>
            <h5 style={{width: "50px"}}>-</h5>
            <h5 style={{marginLeft: "5px", color: config.color.textColor}}>{matchInfo.room_id}</h5>
          </div>
          <div className='d-flex' style={{marginBottom: "10px"}}>
            <h5 style={{width: "120px",color: config.color.textColor}}>Date</h5>
            <h5 style={{width: "50px"}}>-</h5>
            <h5 style={{marginLeft: "5px", color: config.color.textColor}}>{timeAgo(matchInfo?.logged_date)}</h5>
          </div>
          {matchInfo?.data?.split("\n").map(d => <h5 style={{color: config.color.textColor, marginBottom: "15px"}}>{d}</h5>)}
        </div>
        }

        {!loading && !matchInfo && latestMatches.length > 0 && 
          <div style={{display: 'flex', flexDirection: 'row', alignItems: "center", marginTop: "20px"}}>
            <h5 style={{color: config.color.textColor, margin: 0, fontStyle: "italic"}}>Latest Matches</h5> 
            <ButtonBase style={{marginLeft: "10px"}} onClick={()=> setRefresh(pre=> !pre)}>
              <i className="mdi mdi-refresh" style={{fontSize: "20px"}}></i>
            </ButtonBase>
          </div>
        }
        {
          !loading && !matchInfo && latestMatches.length > 0 &&
          latestMatches.map(d => {
            return (
              <div style={{marginTop: "30px", padding: "20px", backgroundColor: "#2A3042", borderRadius: "5px"}}>
                <div className='d-flex' style={{marginBottom: "10px"}}>
                  <h5 style={{width: "120px", color: config.color.textColor}}>Match Id</h5>
                  <h5 style={{width: "50px"}}>-</h5>
                  <h5 style={{marginLeft: "5px", color: config.color.secondaryColor}}>{d.match_id}</h5>
                </div>
                <div className='d-flex' style={{marginBottom: "10px"}}>
                  <h5 style={{width: "120px",color: config.color.textColor}}>Room Id</h5>
                  <h5 style={{width: "50px"}}>-</h5>
                  <h5 style={{marginLeft: "5px", color: config.color.textColor}}>{d.room_id}</h5>
                </div>
                <div className='d-flex' style={{marginBottom: "10px"}}>
                  <h5 style={{width: "120px",color: config.color.textColor}}>Date</h5>
                  <h5 style={{width: "50px"}}>-</h5>
                  <h5 style={{marginLeft: "5px", color: config.color.textColor}}>{timeAgo(d?.logged_date)}</h5>
                </div>
                {d?.data?.split("\n").map(d => <h5 style={{color: config.color.textColor, marginBottom: "15px"}}>{d}</h5>)}
              </div>
            )
          })
        }
        
    </div>
  )
}
